<template lang="pug">
  .circle-btn-container( :class="{ alive:isAlive }" )
    .circle-btn( :class="{ clicked:isClicked }", @click="onClick" ) {{text}}
</template>

<script>
export default {
  props: {
    text: String,
    isAlive: Boolean
  },

  data() {
    return {
      isClicked: false
    };
  },

  methods: {
    onClick() {
      this.isClicked = true;
      this.$emit("onClick");

      setTimeout(() => {
        this.isClicked = false;
      }, 50);
    }
  }
};
</script>

<style scoped lang="scss">
.circle-btn-container {
  width: 120px;
  height: 120px;
  margin-bottom: 2rem;
  transition: all 0.25s ease;
  transform: scale(0, 0);

  &.alive {
    transform: scale(1, 1);
  }

  .circle-btn {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 50%;
    font-family: "ELECNA", sans-serif;
    font-size: 2.5rem;
    cursor: pointer;
    cursor: hand;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.25s ease;

    &:hover {
      opacity: 0.8;
    }

    &.clicked {
      transform: scale(0.75, 0.75);
    }
  }
}
</style>
